import {RequestOptions} from "rxjs-ajax-request"

// Services
import AuthService from "../../auth/services/AuthService"

// Models
import DoctorStatsServiceType from "./DoctorStatsServiceType"
import AuthServiceType from "../../auth/services/AuthServiceType"
import HttpServiceType from "../../http/services/HttpService/HttpServiceType"

// Constants
import {StatsEndpoint} from "../constants"

const DoctorStatsService: DoctorStatsServiceType
    & AuthServiceType
    & HttpServiceType = Object.create(AuthService);

/**
 * @param id
 */
DoctorStatsService.fetchStats = function fetchStats(id: string) {
    return this.request(`${this.getApiUrl()}${StatsEndpoint.STATS.replace("{id}", id)}`, {
        headers: this.getAuthHeader(),
    })
};

/**
 * @param id
 * @param search
 */
DoctorStatsService.fetchAvailableRecords = function fetchAvailableRecords(id: string, search: RequestOptions["search"]) {
    return this.request(`${this.getApiUrl()}${StatsEndpoint.AVAILABLE_RECORDS.replace("{id}", id)}`, {
        headers: this.getAuthHeader(),
        search,
    })
};

/**
 * @param id
 */
DoctorStatsService.fetchInProgress = function fetchInProgress(id: string) {
    return this.request(`${this.getApiUrl()}${StatsEndpoint.RECORD_IN_PROGRESS.replace("{id}", id)}`, {
        headers: this.getAuthHeader(),
    })
};

export default DoctorStatsService
